import { Button, Card, Table } from 'antd';
import type { ColumnType } from 'antd/es/table';
import React, { useState } from 'react';

import { CARD_BODY_STYLES, CARD_HEAD_STYLES } from '../../constants';
import { AddOrEditModal } from './components/AddOrEditModal';
import { DUMMY_TICKET_DISTRIBUTIONS } from './constants';
import { getTableColumnsWithoutActionColumn } from './helpers';
import styles from './index.module.scss';
import type { TicketDistributionData } from './types';

export const TicketDistribution = () => {
  const [showModal, setShowModal] = useState(false);
  const [ticketDistributionData, setTicketDistributionData] = useState<
    TicketDistributionData | undefined
  >(undefined);

  const closeModal = () => {
    setTicketDistributionData(undefined);
    setShowModal(false);
  };

  const actionColumn: ColumnType<TicketDistributionData> = {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    render: (_, record) => {
      return (
        <div className={styles.tableActionButtons}>
          <Button
            onClick={() => {
              setTicketDistributionData(record);
              setShowModal(true);
            }}
          >
            編輯
          </Button>
          <Button
            type="primary"
            danger
            onClick={() => {
              console.log('Delete!\n', record);
            }}
          >
            刪除
          </Button>
        </div>
      );
    },
  };

  const tableColumns = [...getTableColumnsWithoutActionColumn(), actionColumn];

  return (
    <>
      <div className={styles.container}>
        <Button
          className={styles.addDistributionButton}
          onClick={() => setShowModal(true)}
        >
          新增票券發放
        </Button>
        <Card
          title="票券發放"
          headStyle={CARD_HEAD_STYLES}
          bodyStyle={CARD_BODY_STYLES}
        >
          <Table
            bordered
            rowKey="_id" // TODO: 看rowKey到時候有沒有變，有變再改
            scroll={{ x: 'max-content' }}
            columns={tableColumns}
            // TODO: 假資料，記得改
            dataSource={DUMMY_TICKET_DISTRIBUTIONS}
          />
        </Card>
      </div>
      <AddOrEditModal
        showModal={showModal}
        closeModal={closeModal}
        ticketDistributionData={ticketDistributionData}
      />
    </>
  );
};
